import { createApp } from 'vue'
import '../app.css'
import App from '../App.vue'
import router from '../router'
import { initSentry } from '../lib/sentry'

const app = createApp(App)

initSentry(app, router)

app.use(router)

app.mount('#app')
